import { fetchDelete } from ".";

export const confirmDeletePost = async (postId) => {
  if (window.confirm("Are you sure you want to delete this post?")) {
    const { body, error } = await fetchDelete({
      data: { postId },
      onError: console.error,
      url: "/api/wiki",
    });
    return { body, error };
  }
};
